import type { ICellRendererParams } from 'ag-grid-community';

import { useCrmUrl } from '@/utils/crm-url';

import { CreatedFertType } from '../types';

export const FertAccount = ({
  value,
  data,
}: ICellRendererParams<CreatedFertType>) => {
  const baseUrl = useCrmUrl();
  if (!baseUrl) {
    return value;
  }

  const url = new URL('main.aspx', baseUrl);
  url.searchParams.set('etc', '1');
  url.searchParams.set(
    'extraqs',
    'formid=b053a39a-041a-4356-acef-ddf00182762b',
  );
  url.searchParams.set('id', `{${data?.accountID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
